import Shop from '../shop';

export default class SoccerTeam extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Soccer team',
            id:                   'SoccerTeam',
            coolDown:             600,
            faClass:              'fa-soccer-ball-o',
            individualCostFactor: 1.125,
            baseEarnings:         7464000.0,
            baseCosts:            14929920.0,
            grade:                7
        });
    }
}
